import { type AvailableDate } from '@/features/listing/components/request-viewing/RequestViewForm/RequestViewingForm'
import { MAX_AVAILABLE_DATES } from '@/features/listing/components/request-viewing/RequestViewing'

type GenerateRequestViewingAttemptTrackingLabelParams = {
  fullName: string
  availableDates: AvailableDate[]
  listingId: string
}

/**
 * Generates a tracking label for an attempt to request a viewing. It returns an encoded string with the full name and the available dates.
 *
 * @param params - The parameters for generating the tracking label.
 * @param params.fullName - The full name of the user. E.g John Doe.
 * @param params.availableDates - The available dates for viewing. E.g  '2021-01-01', timeFrom: '09:00', timeTo: '12:00' }].
 * @param params.listingId - The ID of the listing. E.g 7483439.
 * @returns The generated tracking label. E.g: full_name=1;option_1=1;option_2=0;option_3=0;ad_id=7483439
 */
export const generateRequestViewingAttemptTrackingLabel = ({
  fullName,
  availableDates,
  listingId,
}: GenerateRequestViewingAttemptTrackingLabelParams) => {
  let trackingData = ''

  trackingData += `full_name=${fullName ? '1' : '0'}`

  for (let i = 0; i < MAX_AVAILABLE_DATES; i++) {
    const optionNumber = i + 1
    const availableDate = availableDates[i]
    if (availableDate?.date && availableDate.timeFrom && availableDate.timeTo) {
      trackingData += `;option_${optionNumber}=1`
    } else {
      trackingData += `;option_${optionNumber}=0`
    }
  }

  trackingData += `;ad_id=${listingId}`

  return trackingData
}
